import { Outlet, useLocation, Navigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { ArrowBarLeft, ArrowBarRight, Grid1x2, Display, Person, BusFront, BagPlus, Tools, ChevronDown, ChevronUp} from 'react-bootstrap-icons'
import { AuthService } from '../../services';
import { useNavigate } from 'react-router-dom';
import { readPageUiObject, writePageUiObject } from '../../shared/pageFilterPersistence';




const SideMenu = () => {
	const SIDEBAR_COLLAPSE_SESSION_LEGACY_KEY = 'globalSidebarIsCollapsed';
	const SIDEBAR_PAGE_UI_KEY = 'global_sidebar';
	const sideNavs = [
		{
			icon: <Grid1x2 color="#777" size={14}/>,
			name: 'Dashboard',
			collapsed: false,
			roleFunc: () => AuthService.canViewDashboard() || AuthService.canViewAdminView(),
			subNavs: [
				{
					name: 'Dashboard',
					link: '/dashboard/dashboard',
					category: '/dashboard/dashboard',
					roleFunc: AuthService.canViewDashboard
				},
				{
					name: 'Admin View',
					link: '/dashboard/admin-view',
					category: '/dashboard/admin-view',
					roleFunc: AuthService.canViewAdminView
				}
			]
		},
		{
			icon: <Display color="#777" size={14}/>,
			name: 'Info Screen',
			link: '/info-screen',
			roleFunc: AuthService.canViewInfoScreen
		},
		{
			icon: <Person color="#777" size={14}/>,
			name: 'General',
			collapsed: false,
			roleFunc: () =>
				AuthService.canViewCustomers() ||
				AuthService.canViewCalendar() ||
				AuthService.canViewCustomerSchedule() ||
				AuthService.canViewMessaging(),
			subNavs: [
				{
					name: 'Customer Information',
					//collapsed: true,
					link: '/customers/list',
					category: '/customers',
					roleFunc: AuthService.canViewCustomers
					// subNavs: [
					// 	{
					// 		name: 'Customer List',
					// 		link: '/customers/list'
					// 	},
					// 	{
					// 		name: 'Create New Customer',
					// 		link: '/customers'
					// 	}
					// ]
				},
				{
					name: 'Customer Schedule',
					link: '/customers/schedule',
					category: '/customers/schedule',
					roleFunc: AuthService.canViewCustomerSchedule
				},
				{
					name: 'Calendar',
					link: '/center-calendar',
					category: '/center-calendar',
					roleFunc: AuthService.canViewCalendar
				},
				{
					name: 'Messaging',
					//collapsed: true,
					link: '/messages/list',
					category: '/messages',
					roleFunc: AuthService.canViewMessaging
					// subNavs: [
					// 	{
					// 		name: 'Messages List',
					// 		link: '/messages/list'
					// 	},
					// 	{
					// 		name: 'Create New Message',
					// 		link: '/messages'
					// 	},
					// 	{
					// 		name: 'Send Message',
					// 		link: '/messages/send-message'
					// 	},
					// 	{
					// 		name: 'Sent Messages List',
					// 		link: '/messages/sent-messages/list'
					// 	}
					// ]
				},
			// 	{
			// 		name: 'Center Phones',
			// 		//collapsed: true,
			// 		link: '/center-phones/list'
			// 		// subNavs: [
			// 		// 	{
			// 		// 		name: 'Center Phones List',
			// 		// 		link: '/center-phones/list'
			// 		// 	},
			// 		// 	{
			// 		// 		name: 'Create New Center Phone',
			// 		// 		link: '/center-phones'
			// 		// 	}
			// 		// ]
			// 	}
			]
		},
		{
			name: 'Transportation',
			icon: <BusFront color="#777" size={14}/>,
			collapsed: false,
			roleFunc: () => AuthService.canViewVechiles() || AuthService.canViewRoutes() || AuthService.canViewRouteTemplates() || AuthService.canViewMedicalEvents(),
			subNavs: [
				{
					name: 'Vehicle Information',
					link: '/vehicles/list',
					category: '/vehicles',
					roleFunc: AuthService.canViewVechiles
					// subNavs: [
					// 	{
					// 		name: 'Vehicles List',
					// 		link: '/vehicles/list'
					// 	},
					// 	{
					// 		name: 'Create New Vehicle',
					// 		link: '/vehicles'
					// 	}
					// ]
				},
				{
					name: 'Transportation Schedule',
					link: '/trans-routes/dashboard',
					category: '/trans-routes/dashboard',
					roleFunc: AuthService.canViewRoutes
				},
				{
					name: 'Templates',
					link: '/trans-routes/daily-templates/list',
					category: '/trans-routes/daily-templates',
					roleFunc: () => AuthService.canViewRouteTemplates() || AuthService.canEditRouteTemplates()
				},
				{
					name: 'Appointment One-Day List',
					link: '/medical/events/list',
					category: '/events/list',
					roleFunc: AuthService.canViewDriverAssignment
				},
				// {
				// 	name: 'Customer Report',
				// 	link: '/admin/customer-report',
				// 	category: '/admin/',
				// 	roleFunc: AuthService.canViewAttendance
				// }
				// {
				// 	name: 'Schedule Driver for Appointment',
				// 	link: '#',
				// 	roleFunc: AuthService.canViewRoutes
				// }
			]
		},
		{
			name: 'Medical',
			icon: <BagPlus color="#777" size={14}/>,
			collapsed: false,
			roleFunc: AuthService.canViewMedicalSection,
			subNavs: [
				{
					name: 'Provider Information',
					link: '/medical/resources/list',
					category: '/resources',
					roleFunc: AuthService.canViewProviderInfo
				},
				{
					name: 'Appointment Requests',
					link: '/medical/event-request/list',
					category: '/event-request',
					roleFunc: AuthService.canViewAppointmentRequests
				},
				{
					name: 'Appointment Calendar',
					link: '/medical/events/calendar',
					category: '/events/calendar',
					roleFunc: AuthService.canViewMedicalEvents
				},
				{
					name: 'Appointment Multi-Days List',
					link: '/medical/events/multiple-list',
					category: '/events/multiple-list',
					roleFunc: AuthService.canViewMedicalEvents
				},
				{
					name: 'Template',
					link: '/medical/template',
					category: '/medical/template',
					roleFunc: AuthService.canViewMedicalTemplate
				},
				{
					name: 'Medical Form',
					link: '/medical/form',
					category: '/medical/form',
					roleFunc: AuthService.canViewMedicalForm
				}
			]
		},
		{
			name: 'Lobby',
			icon: <Tools color="#777" size={14}/>,
			collapsed: false,
			roleFunc: AuthService.canViewLobby,
			subNavs: [
				{
					name: 'Meal Status',
					link: '/meal-status',
					category: '/meal-status',
					roleFunc: AuthService.canViewMealStatus
				},
				{
					name: 'Seating Chart',
					link: '/seating',
					category: '/seating',
					roleFunc: AuthService.canViewSeatingChart
				}
			]
		},
		{
			name: 'Admin',
			icon: <Tools color="#777" size={14}/>,
			collapsed: false,
			roleFunc: () => AuthService.canViewEmployees() || AuthService.canAddOrEditEmployees() || AuthService.canViewApkManagement(),
			subNavs: [
				{
					name: 'Employees',
					link: '/employees/list',
					category: '/employees',
					roleFunc: () => AuthService.canViewEmployees() || AuthService.canAddOrEditEmployees()
				},
				{
					name: 'APK Management',
					link: '/employees/apk-management',
					category: '/employees/apk-management',
					roleFunc: AuthService.canViewApkManagement
				}
			]
		}
	];
  const [collapse, setCollapse] = useState(false);
	const [sidebarUiReady, setSidebarUiReady] = useState(false);
	const [navs, setNavs] = useState(sideNavs)
  const location = useLocation();
	const navigate = useNavigate();
  const showMenu = location.pathname !== '/login' && location.pathname !== '/landing'; // Example: Hide menu on login page
	const getLogoSuffix = () => {
    return (window.location.hostname.includes('worldshine2.mayo.llc') || window.location.hostname.includes('site2') || window.location.host.includes('ws2') ||window.location.hostname.includes('localhost')) ? "Care LLC" : ((window.location.hostname.includes('worldshine3.mayo.llc') ||window.location.hostname.includes('site3') || window.location.hostname.includes('ws3')) ? "Cloverleaf LLC" : "International LLC");
  }

	const toggleMenu = (item) => {
		item.collapsed = !item.collapsed
		const navsCopy = [...sideNavs];
		
		setNavs(navsCopy.map((nav) => item.name === nav.name ? item : nav));
	}

	const goToLink = (link) => {
		navigate(link);
	}

	const isNavCategoryActive = (category, pathname = '') => {
		if (!category) return false;
		// Keep Customer Information from highlighting on Customer Schedule.
		if (category === '/customers') {
			return (
				pathname.startsWith('/customers') &&
				!pathname.startsWith('/customers/schedule')
			);
		}
		if (category === '/employees') {
			return pathname.startsWith('/employees') && !pathname.startsWith('/employees/apk-management');
		}
		return pathname.includes(category);
	};

	useEffect(() => {
		const fromCookie = readPageUiObject(SIDEBAR_PAGE_UI_KEY);
		if (fromCookie && typeof fromCookie.collapsed === 'boolean') {
			setCollapse(fromCookie.collapsed);
		} else {
			const legacy = sessionStorage.getItem(SIDEBAR_COLLAPSE_SESSION_LEGACY_KEY);
			if (legacy === 'true' || legacy === 'false') {
				const next = legacy === 'true';
				setCollapse(next);
				writePageUiObject(SIDEBAR_PAGE_UI_KEY, { collapsed: next });
				try {
					sessionStorage.removeItem(SIDEBAR_COLLAPSE_SESSION_LEGACY_KEY);
				} catch (_e) {}
			}
		}
		setSidebarUiReady(true);
	}, []);

	useEffect(() => {
		if (!sidebarUiReady) return;
		writePageUiObject(SIDEBAR_PAGE_UI_KEY, { collapsed: collapse });
	}, [sidebarUiReady, collapse]);

  return (
		<>
			<div className={`app-side-bar-container${collapse ? ' collapsed' : ''} noprint`}>
		 		<div className={`app-side-bar-logo${collapse ? ' collapsed' : ''}`}>
					<img src="/images/logo-trans.png" />
					{!collapse && <strong className="logo-worldshine">Worldshine</strong>}
					{!collapse && <span className="logo-suffix">{getLogoSuffix()}</span>}
				</div>
				<div className="app-side-bar-menu-container">
					{
						sideNavs.filter(item => item.roleFunc()).map((sideNav) => {
							return <div className={`app-side-bar-list-item-container${collapse ? ' collapsed' : ''}`}>
								<div onClick={() => sideNav.link && goToLink(sideNav.link)} className={`app-side-bar-list-item main-nav-item${isNavCategoryActive(sideNav.category, location?.pathname) ? ' app-side-bar-list-item-active' : '' }`}>
									{ sideNav?.icon ? <>{sideNav.icon}</> : <></>}
									{ !collapse && <span className={`app-side-bar-list-item-name${sideNav?.icon? ' with-icon' : ''}`}>{sideNav.name}</span> }
									{ !collapse && sideNav?.subNavs?.length > 0 && <span onClick={() => toggleMenu(sideNav)} className="float-icon">{sideNav?.collapsed ? <ChevronDown color="#777" size={12}/> : <ChevronUp  color="#777" size={12}/>}</span> }
								</div>
								{
									!collapse && !sideNav?.collapsed && sideNav?.subNavs?.filter(item=> item.roleFunc()).map((subNav) => <div onClick={() => subNav.link && goToLink(subNav.link)} className={`app-side-bar-list-item sub-nav-item${isNavCategoryActive(subNav?.category, location?.pathname) ? ' app-side-bar-list-item-active' : '' }`}>
										{ subNav?.icon ? <>{subNav.icon}</> : <></>}
										{ !collapse && <span className={`app-side-bar-list-item-name${subNav?.icon? ' with-icon' : ''}`}>{subNav.name}</span> }
										{ subNav?.subNavs?.length > 0 && <span onClick={() => toggleMenu(subNav)} className="float-icon">{sideNav?.collapsed ? <ChevronDown color="#777" size={12}/> : <ChevronUp  color="#777" size={12}/>}</span> }
								  </div>)
								}
							</div>
						})
					}
				</div>

				<div className={`app-side-bar-collapse ${collapse ? ' collapsed' : ''}`} onClick={() => setCollapse(!collapse)}>
				  {collapse ? <ArrowBarRight color="#777" size={20} /> : <><ArrowBarLeft color="#777" size={20}/> <span className='collapse-label'>{` Collapse`}</span></>}
				</div>
		 	</div>
		</>
  );
}

export default SideMenu;